<template>
  <div class="container" ontouchmove="touchScroll">
    <div class="header-banner">
      <img class="header-img" src="https://wecos.etczs.net/assets/images/new-index-header-1121.png" />
      <!-- <div @click="showWelfareBox" class="welfare-view">享最高20万元高速险，全国高速95折等</div> -->
    </div>
    <!-- <div class="news-bar">
      <img class="news-bar-tag" src="https://wecos.etczs.net/assets/images/index-news-logo-1024.png" />
      <div class="news-bar-title">
        ETC车道将覆盖90%以上，今年免费领
      </div>
    </div> -->
    <div ref="buttonWrap" class="button-wrap">
      <div :class="{'button-fixed':fixedButton}">
        <button @click="apply" class="apply-btn">客车ETC办理</button>
        <div @click="m_customService" to="" class="custom-link">联系客服</div>
      </div>
    </div>
    <!-- 领取流程 -->
    <div class="step-desc" @click="showStep">
      <div class="step-title">领取流程</div>
      <div class="step-container">
        <div class="step-item">
          <div class="step-time">
            <span class="num">35</span>
            <span>秒</span>
          </div>
          <div class="time-tips">在线办理</div>
        </div>
        <div class="arrow">
          <img class="arrow-r" src="https://wecos.etczs.net/assets/images/new-index-arrow-r-1114.png" />
        </div>
        <div class="step-item">
          <div class="step-time">
            <span class="num">6</span>
            <span>小时</span>
          </div>
          <div class="time-tips">最快发货</div>
        </div>
        <div class="arrow">
          <img class="arrow-r" src="https://wecos.etczs.net/assets/images/new-index-arrow-r-1114.png" />
        </div>
        <div class="step-item">
          <div class="step-time">
            <span class="num">1</span>
            <span>分钟</span>
          </div>
          <div class="time-tips">安装激活</div>
        </div>
      </div>
      <div class="step-more">查看详细步骤</div>
    </div>
    <!-- 产品特色 -->
    <div class="prod-desc">
      <div class="prod-title">产品特色</div>
      <div class="prod-container">
        <div class="prod-item">
          <img class="prod-item-img" src="https://wecos.etczs.net/H5/newApply/h5-index-prod-1-0121.png" />
          <div class="item-text-container">
            <div class="item-text"> • 在线提交申请</div>
            <div class="item-text"> • 快递包邮到家</div>
            <div class="item-text"></div>
          </div>
        </div>
        <div class="prod-item w">
          <img class="prod-item-img" src="https://wecos.etczs.net/H5/newApply/h5-index-prod-2-0121.png" />
          <div class="item-text-container">
            <div class="item-text"> • 30秒安装设备</div>
            <div class="item-text"> • 微信一键激活</div>
            <div class="item-text"></div>
          </div>
        </div>
      </div>
      <div class="prod-container">
        <div class="prod-item">
          <img class="prod-item-img" src="https://wecos.etczs.net/H5/newApply/h5-index-prod-3-0121.png" />
          <div class="item-text-container">
            <div class="item-text"> • 免充值无手续费</div>
            <div class="item-text"> • 微信账单通知</div>
            <div class="item-text"></div>
          </div>
        </div>
        <div class="prod-item w">
          <img class="prod-item-img long" src="https://wecos.etczs.net/H5/newApply/h5-index-prod-4-0121.png" />
          <div class="item-text-container">
            <div class="item-text"> • ETC定制设备</div>
            <div class="item-text"> • 无法被盗刷</div>
            <div class="item-text"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="company-info">
      <div class="company-info-title">公司介绍</div>

      <div class="text">
        安徽高灯微行科技有限公司于2017年5月成立，是一家以发票数字化为基础，通过构建去人工化、在线化、科技合规的行业专业云设施，面向企业和监管提供财税合规及交易合规管理平台的财税科技公司。
      </div>
      <div class="text">
        地址：安徽省合肥市高新区天源迪科南门1号楼12层
      </div>
      <div class="text">
        电话：4008291777
      </div>
    </div>
    <!-- 相关服务 -->
    <div class="apply-services">
      <div class="service-title">相关服务</div>
      <div class="service-list">
        <div class="service-item">
          <img class="service-img" src="https://wecos.etczs.net/assets/images/service-img-no1-0810.png" />
          <div class="service-text">质保两年</div>
        </div>
        <div class="service-item">
          <img class="service-img" src="https://wecos.etczs.net/assets/images/service-img-no2-0810.png" />
          <div class="service-text">专业客服</div>
        </div>
        <div class="service-item">
          <img class="service-img" src="https://wecos.etczs.net/assets/images/service-img-no3-0810.png" />
          <div class="service-text">高速发票</div>
        </div>
        <div class="service-item">
          <img class="service-img" src="https://wecos.etczs.net/assets/images/service-img-no4-0810.png" />
          <div class="service-text">在线售后</div>
        </div>
      </div>
    </div>
    <!-- 常见问题 -->
    <div class="apply-qa">
      <div class="qa-title" data-type="title">
        常见问题
      </div>
      <div class="qa-content">
        <template index="index" item="item" v-for="(item,index) in qaList">
          <div :key="index" class="qa-item">
            <div class="qa-item-tag">Q</div>
            <div class="qa-item-question">{{item.question}}</div>
            <div class="qa-item-answer">{{item.answer}}</div>
          </div>
        </template>
      </div>
      <!-- <div class="more-qa" @tap="navToPage('/pages/main/qa?page_id=5000150&card_id=0')">更多问题</div> -->
      <div class="more-qa" @click="m_goPages('applyQA')">查看更多问题</div>
    </div>

    <workflow @close="workflowShow=false" :show="workflowShow"></workflow>
    <!-- <welfare-box @close="welfareShow=false" :show="welfareShow"></welfare-box> -->
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
import ChannelMixin from '@/mixins/channelMixin'

import ETC from '@/config/etc.config'

// Components
import workflow from './components/workflow'
// import welfareBox from './components/welfare-box'
import UserApi from '@/api/user.api'
import Plugins from '@/utils/plugins'
import ETCUtil from '@/utils/util.etc'
import reconApply from '@/api/reconApply.api'
import ApplyApi from '@/api/apply.api'

import GoodsDetail from './goodsDetail'
import { mapState, mapMutations } from 'vuex'
let customData = {
  isAndroid: false,
  cannotTip: '',
  isLogin: false,
  jumpParams: ''
}
export default {
  data: () => ({
    qaList: ETC.NEW_APPLY_QA.slice(0, 3),
    workflowShow: false,
    // welfareShow: false,
    fixedButton: false
  }),
  mixins: [GoodsDetail, FunMixin, BiMixin, ChannelMixin],
  components: {
    workflow
    // welfareBox
  },
  computed: {
    ...mapState([
      'currentOrder',
      'userLocation',
      'userApplyStep',
      'currentCard',
      'applyStepList'
    ])
  },
  methods: {
    showStep() {
      this.workflowShow = true
    },
    // showWelfareBox() {
    //   this.welfareShow = true
    // },
    observerButtonWrap() {
      if (!window.IntersectionObserver) return false
      this.observer = new IntersectionObserver(mutations => {
        const intersectionRect = mutations[0].intersectionRect
        this.fixedButton = !intersectionRect.bottom
      })
      this.observer.observe(this.$refs.buttonWrap)
    },
    goRepay() {
      this.m_goPages('throughRec_zh')
    },
    hidePopup() {
      this.$refs.popup.$emit('hidePopup')
    },
    goSpecialBack() {
      console.log('goSpecialBack')
    },
    UPUP() {
      window.scrollTo(0, 0)
    },
    startVideo() {
      this.$refs.video.play()
      this.$refs.video.setAttribute('controls', 'controls')
      this.video.start = true
      this.biLog({ eventID: 2001140 })
    },
    async showModal(t) {
      await this.m_clickDebounce('showModal')
      this.$refs.modal.$emit('showModal', {
        contentSlot: true,
        defaultFooter: false,
        parentHide: true,
        close: true
      })
      this.m_scroll(false)
      this.modalType = t
    },
    modalHide() {
      this.m_scroll(true)
    },
    // async getLocation() {
    //   let pos
    //   // 5秒后没获取到定位就跳转
    //   let timer = setTimeout(() => {
    //     return Promise.resolve('end')
    //   }, 5000)
    //   try {
    //     pos = await Plugins.getLocation(this.appChannel)
    //     console.log('plugin get location success', pos)
    //     this.setUserLocation({latitude: pos.latitude, longitude: pos.longitude})
    //   } catch (e) {
    //     console.log('get location err', e)
    //   }
    //   clearTimeout(timer)
    //   return Promise.resolve('end')
    // },
    async getUserOrderInfo(type) {
      sessionStorage.setItem('notFirstLoad', 1)
      console.log(
        'goods detail getUserOrderInfo type:',
        type,
        ' uid:',
        localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID)
      )
      try {
        const userInfo = await UserApi.getUserInfo()
        // const checkRepay = userInfo.user_cards && userInfo.user_cards.find(({card_id}) => card_id === 27)
        // 招行还款入口
        if (this.appChannel === 'zhaohang') {
          const res = await ApplyApi.getZHRepayStatus()
          if (res.has_repayment) {
            this.$refs.popup.$emit('showPopup', {class: 'zhaohang-repay-popup'})
            return
          }
        }
        customData.jumpParams = {
          orderSn: userInfo.apply_order_sn
        }
        // 有卡用户进入绑定成功页
        // 跳转后取消自动
        localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, '')
        if (userInfo.has_card) {
          if (this.appChannel === 'zhaohang') {
            const zhaohangCard = userInfo.user_cards.find(
              ele => ele.toll_pay_channel === 3
            )
            if (zhaohangCard) {
              if (zhaohangCard.entrust_status !== 1) {
                return this.m_showConfirm({ content: '你的ETC扣款协议已失效，ETC费用已无法自动扣款，我们根据高速公路收费中心要求，已将你的ETC添到全国高速公路黑名单。为了不影响你的出行，请尽快完成重新签约，签约成功后我们将你的ETC恢复正常使用', noCancel: true, confirmBtn: '重新签约' }).then(
                  async res => {
                    if (res) {
                      try {
                        const res = await reconApply.entrustSignContract({
                          payment_mode: 5,
                          purchase_party: 6
                        })
                        if (res && res.contract) {
                          localStorage.setItem('zhanghangEntrust', 'yes')

                          console.log(
                            'res.contractres.contractres.contract',
                            res.contract
                          )
                          location.href =
                            res.contract.url +
                            '&jsonRequestData=' +
                            res.contract.tmpData
                          // this.m_awaitTime(2000)
                          // this.getEntrustStatus(4000)
                        }
                      } catch (error) {}
                    }
                  }
                )
              } else {
                // 招行签约返回需要提示
                if (localStorage.getItem('zhanghangEntrust') === 'yes') {
                  localStorage.removeItem('zhanghangEntrust')
                  await this.m_showConfirm({ content: '你的ETC扣款协议已签约成功，若无欠费等异常行为，我们将为你在48小时内恢复ETC的正常使用，若还有欠费请主动进行还款', noCancel: true })
                }
              }
            }
          }
          customData.jumpParams = {
            ...customData.jumpParams,
            cardId: userInfo.user_cards[0].id,
            plateNo: userInfo.user_cards[0].plate_no,
            issuerName: userInfo.user_cards[0].card_name
          }
          return ETCUtil.goApplyPage(
            'bindSuccess',
            {},
            this.$router,
            customData.jumpParams,
            1
          )
        }
        // 重构订单不同判断订单走不通的接口
        // 用户没卡
        if (userInfo.apply_order_sn) {
          // 有订单
          // 查询用户订单reconApply
          const {
            order,
            reject_reason,
            step_list
          } = await reconApply.getApplyCurrentOrder({
            order_sn: userInfo.apply_order_sn
          })
          // 保存发卡方，卡信息
          this.setCurrentIssuer(order.card_issuer)
          this.setCurrentCard(order.card)
          this.setCurrentOrder({ reject_reason, ...order })
          this.setApplyStepList(step_list)
          customData.jumpParams.plateNo = this.currentOrder.plate_no || ''
          return ETCUtil.goApplyPage(
            'goodsAddress',
            step_list,
            this.$router,
            customData.jumpParams,
            0,
            type
          )
        }
        if (type === 'click') {
          this.$router.push('goodsAddress')
        }
      } catch (e) {
        console.log('goods detail getUserOrderInfo catch', e)
        throw new Error('goods detail  getUserOrderInfo err' + e)
      } finally {
        console.log('goods detail getUserOrderInfo finally')
        this.m_loadingClose()
      }
    },
    async apply() {
      if (customData.cannotTip) {
        this.m_showConfirm({ content: customData.cannotTip })
        return
      }
      // 招行签约后返回 会出现无参数的状态
      if (
        !customData.isLogin &&
        !localStorage.getItem(ETC.LOCAL_STORAGE_KEY.TOKEN)
      ) {
        let { enterP } = this
        console.log('enterP', enterP)
        // 如果没有UID则调用手机号码登录
        if (
          !enterP.uid &&
          !enterP.userToken &&
          !enterP.qz_gdt &&
          this.appChannel !== 'zuizhuhai'
        ) {
          // 登录后需要调用部分该页面逻辑
          this.$eventBus.$once('onLogin', async res => {
            if (res) {
              customData.isLogin = true
              // 登录成功挟持router把登录页面replace掉阻止返回
              let cancelEach = this.$router.beforeEach((to, from, next) => {
                if (from.name === 'verifyPhone') {
                  cancelEach()
                  this.$router.replace(to)
                }
              })
              await this.initLoginStore()
              this.apply()
            }
          })
          this.$router.push('/verify-phone?callback=onLogin')
          return
        } else {
          customData.isLogin = await this.c_channelLogin()
          if (!customData.isLogin) return
        }
      }
      this.m_showLoading()
      // 没有地理位置，点击获取地理位置
      try {
        this.biLog({ eventID: 2001129 })
        // if (
        //   localStorage.getItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD) === 'yes'
        // ) {
        //   }
        await this.getUserOrderInfo('click')
        // else {
        //   console.log(
        //     23232,
        //     'goodsAddress',
        //     this.applyStepList.step_list,
        //     this.$router,
        //     'click',
        //     customData.jumpParams
        //   )
        //   ETCUtil.goApplyPage(
        //     'goodsAddress',
        //     this.applyStepList.step_list,
        //     this.$router,
        //     customData.jumpParams,
        //     'click'
        //   )
        // }
      } catch (e) {
        throw new Error('goods detail apply err' + e)
      } finally {
        this.m_loadingClose()
      }
    },
    async initLoginStore() {
      try {
        this.m_showLoading()
        // province freight_fee
        // 根据ip定位  浏览器定位太过耗时
        // if (!this.userLocation.latitude) {
        //   await this.getLocation()
        // }
        const {
          issuer,
          card,
          comments,
          recent_orders,
          province
        } = await reconApply.getApplyGoodsDetail({
          // longitude: this.userLocation.longitude,
          // latitude: this.userLocation.latitude
        })
        this.setUserLocation({ province })
        this.setCurrentCard(card)
        this.setCurrentIssuer(issuer)
        this.comments = comments
        recent_orders && (this.topApplys = recent_orders[0])
        // 如果是支付成功回来
        const pageType = localStorage.getItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD)
        if (!pageType || pageType === 'yes') {
          await this.m_awaitTime(3000)
          this.getUserOrderInfo('auto')
        } else if (!sessionStorage.getItem('notFirstLoad')) {
          this.getUserOrderInfo('auto')
        }
      } catch (e) {
        console.log('goods detail err', e)
      } finally {
        this.m_loadingClose()
      }
    },
    ...mapMutations([
      'setCurrentCard',
      'setCurrentIssuer',
      'setUserApplyStep',
      'setUserLocation',
      'setCurrentOrder',
      'setApplyStepList'
    ])
  },
  async created() {
    console.log(process.env)
    if (this.appChannel === 'zhaohang') {
      document.title = '服务暂停'
      await Plugins.appStartDefer.promise
      console.log('zhaohang ver ', this.c_channelAppVersion())
      if (this.c_channelAppVersion() >= '7.4.0') {
        // cmblapi.applet({
        //   api: 'checkAppletContainer',
        //   success: () => { // 如果是小程序容器，这里回调
        //     console.log('checkAppletContainer success')
        //     cmblapi.applet({
        //       api: 'setAppletBackButton',
        //       params: {
        //         btnAction: 'default' // 支持default或executeJs
        //         // btnActionContent:'null/window.history.go(-1)'
        //       },
        //       success: () => {
        //         console.log('setAppletBackButton success')
        //         // window.cmblapi.applet({
        //         //   api: 'popWindow',
        //         //   fail: (res) => {
        //         //     console.log('popWindow fail', res)
        //         //   }
        //         // })
        //       },
        //       fail: (res) => {
        //         console.log('setAppletBackButton fail', res)
        //       }
        //     })
        //   },
        //   fail: (res) => { // 如果不是小程序容器，这里回调
        //     console.log('checkAppletContainer fail, res')
        //   }
        // })
      } else {
        if (!this.c_channelIsLogin()) return
        window.CMBLS.TopBarUI = window.CMBLS.TopBarUI || {}
        window.CMBLS.TopBarUI.callback = (id, message) => {
          console.log('TopBarUI callback ' + id)
          if (customData.isAndroid) {
            window.location = 'http://cmbandroid/tool'
          } else {
            window.location = 'http://cmbiphone/tool'
          }
        }
        window.cmblsJSExecutor(
          'http://cmbls/TopBarUI?id=2222&left_btn_style=' +
            encodeURIComponent(
              JSON.stringify([
                {
                  btnType: 'goback',
                  actionType: 'callback'
                }
              ])
            )
        )
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    // console.log('beforeRouteLeave bbbbbb')
    localStorage.setItem(ETC.LOCAL_STORAGE_KEY.HOME_RELOAD, '')
    console.log('this.appChannel', this.appChannel)
    if (this.appChannel === 'zhaohang') {
      if (this.c_channelAppVersion() >= '7.4.0') {
      } else {
        window.CMBLS.TopBarUI = window.CMBLS.TopBarUI || {}
        window.CMBLS.TopBarUI.successCallback = (id, message) => {
          console.log('TopBarUI ' + id)
        }
        window.cmblsJSExecutor(
          'http://cmbls/TopBarUI?id=111&left_btn_style=' +
            encodeURIComponent(
              JSON.stringify([
                {
                  btnType: 'goback',
                  actionType: 'historygoback'
                }
              ])
            )
        )
      }
    }
    next()
  },
  async mounted() {
    this.observerButtonWrap()

    console.log('goodsDetail mounted 233334')
    await Plugins.appStartDefer.promise
    const enterP = (this.enterP =
      Object.keys(this.$route.query).length === 0
        ? Object.keys(this.$route.params).length === 0
          ? {}
          : this.$route.params
        : this.$route.query)
    customData.isAndroid = await this.m_isAndroid()
    let appChannel = enterP.channel || this.appChannel || ''
    if (!appChannel || !ETC.APP_LOGIN_TYPES[appChannel]) {
      this.m_goPages('goodsDetailV1')
      // customData.cannotTip = '入口已关闭，请前往微信“ETC助手”小程序办理'
      // this.m_showConfirm({ content: customData.cannotTip })
      return
    }

    // 处理滴滴uid占位符问题：
    if (enterP.uid === '__UID__' /* || enterP.uid === 'XXXX' */) {
      enterP.uid = void 0
    }

    // 若页面没有参数
    customData.isLogin = ETCUtil.getToken()
    if (
      (!enterP.uid || !enterP.code) &&
      !enterP.userToken &&
      !enterP.qz_gdt &&
      !localStorage.getItem(ETC.LOCAL_STORAGE_KEY.UUID)
    ) {
      // customData.cannotTip = appChannel ? '请前往"' + ETC.APP_EVNS_CN[appChannel] + '"查看详情' : '该页面无效，请在微信搜索“etc助手”小程序办理'
      // this.m_showConfirm({content: customData.cannotTip})
      if (customData.isLogin) {
        return this.initLoginStore()
      }
    }
    if (!customData.isLogin) {
      customData.isLogin = await this.c_channelLogin()
    }
    if (!customData.isLogin) return
    this.initLoginStore()
  }
}
</script>

<style lang="scss" scoped>
.container {
  background: #f5f5f5;
  overflow: hidden;
}
.header-banner {
  position: relative;
  background: #fff;
  padding-top: 20px;
  .welfare-view {
    position: absolute;
    padding: 0px 20px;
    line-height: 52px;
    border-radius: 26px;
    font-size: 24px;
    color: #16c88b;
    background-color: rgba(22, 201, 139, 0.1);
    top: 107px;
    left: 40px;
    padding-right: 40px;
    &::after {
      position: absolute;
      right: 20px;
      top: 50%;
      display: block;
      content: '';
      width: 12px;
      height: 12px;
      margin-left: 12px;
      border-right: 4px solid #16c88b;
      border-bottom: 4px solid #16c88b;
      transform: translateY(-50%) rotate(-45deg);
    }
  }
  .header-img {
    display: block;
    width: 100%;
  }
}

.news-bar {
  height: 120px;
  background-color: #fff;
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 55px;
  z-index: 1;
  // box-sizing: border-box;
  .news-bar-tag {
    display: block;
    width: 71px;
    height: 55px;
    padding-right: 20px;
    border-right: 1px solid #ddd;
  }
  .arrow-r {
    display: block;
    height: 32px;
    width: 32px;
  }
  .news-bar-title {
    margin-left: 20px;
    margin-right: 30px;
    line-height: 52px;
    width: 480px;
    height: 52px;
    // background-color: rgba(249,78,54,0.07);
    color: #666;
    font-size: 28px;
    font-weight: 500;
    border-radius: 26px;
    overflow: hidden;
    .theswiper {
      height: 52px;
      .item {
        height: 52px;
      }
    }
  }
}

// 领取流程
.step-desc {
  margin: 20px auto 0;
  width: 710px;
  border-radius: 16px;
  background-color: #fff;
  .step-title {
    padding: 30px 0 30px;
    font-weight: bold;
    text-align: center;
    font-size: 32px;
    line-height: 45px;
    color: #333;
  }
  .step-container {
    display: flex;
    padding: 0 60px 30px;
    justify-content: space-between;
    .step-item {
      text-align: center;
    }
    .step-time {
      color: #16c88b;
      font-size: 28px;
      line-height: 40px;
      .num {
        font-style: italic;
        font-weight: bold;
        font-size: 60px;
        line-height: 71px;
        padding-right: 10px;
      }
    }
    .time-tips {
      color: #666;
      font-size: 28px;
      line-height: 40px;
    }
    .arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      .arrow-r {
        display: block;
        width: 32px;
        height: 32px;
      }
    }
  }
  .step-more {
    border-top: 1px solid #ddd;
    text-align: center;
    line-height: 80px;
    font-size: 28px;
    color: #666;
  }
}
// 产品特色
.prod-desc {
  margin: 20px auto 0;
  width: 710px;
  border-radius: 16px;
  background-color: #fff;
  .prod-title {
    padding: 30px 0 40px;
    text-align: center;
    font-weight: bold;
    font-size: 32px;
    line-height: 45px;
    color: #333;
  }
  .prod-container {
    display: flex;
    justify-content: space-between;
    padding: 0 60px 40px 40px;
    .prod-item.w {
      width: 230px;
      .item-text-container {
        margin-left: 16px;
      }
    }
    .prod-item-img {
      display: block;
      margin: 0 auto;
      width: 184px;
      height: 50px;
      padding-bottom: 13px;
      &.long {
        width: 228px;
      }
    }
    .item-text {
      font-size: 24px;
      line-height: 33px;
      color: #666;
    }

  }
}
.company-info {
   margin: 20px auto 0;
  width: 710px;
  border-radius: 16px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 30px;

    .company-info-title {

    text-align: center;
    font-weight: bold;
    font-size: 32px;
    line-height: 45px;
    color: #333;
    }
    .text {
      font-size: 24px;
      line-height: 33px;
      color: #666;
      margin-top: 12px;

    }
}
// 相关服务
.apply-services {
  margin: 20px auto 0;
  width: 710px;
  border-radius: 16px;
  background-color: #fff;
  .service-title {
    padding: 30px 0 30px;
    text-align: center;
    font-weight: bold;
    font-size: 32px;
    line-height: 45px;
    color: #333;
  }
  .service-list {
    display: flex;
    .service-item {
      flex: 1;
    }
    .service-img {
      display: block;
      margin: 0 auto;
      width: 50px;
      height: 50px;
    }
    .service-text {
      padding: 20px 0 50px;
      font-size: 28px;
      line-height: 40px;
      color: #666;
      font-weight: 500;
      text-align: center;
    }
  }
}
// 常见问题
.apply-qa {
  position: relative;
  margin: 20px auto 0;
  width: 710px;
  border-radius: 16px;
  margin-bottom: 280px;
  box-sizing: border-box;
  font-size: 30px;
  background-color: #fff;
  .qa-title {
    font-size: 32px;
    line-height: 45px;
    font-weight: bold;
    padding: 30px 0 30px;
    text-align: center;
    color: #333;
  }
  .qa-content {
    // padding: 0 20px;
    .qa-item {
      position: relative;
      margin-bottom: 20px;
      padding: 20px 20px 20px 70px;
      .qa-item-tag {
        position: absolute;
        top: 24px;
        left: 20px;
        width: 30px;
        height: 30px;
        background-color: #16c88b;
        border-radius: 50% 50% 50% 0;
        font-size: 20px;
        line-height: 30px;
        color: #fff;
        text-align: center;
      }
      .qa-item-question {
        font-size: 32px;
        line-height: 45px;
        color: #333;
        font-weight: 500;
      }
      .qa-item-answer {
        font-size: 28px;
        line-height: 42px;
        color: #666;
        padding-top: 10px;
      }
    }
  }
  .more-qa {
    border-top: 1px solid #ddd;
    text-align: center;
    font-size: 28px;
    line-height: 80px;
    color: #666;
  }
}
.welfare-toast {
  border-radius: 32px 32px 0 0;
}
.welfare-box {
  .welfare-title {
    position: relative;
    font-weight: 500;
    padding: 40px 0px 50px;
    font-size: 36px;
    line-height: 50px;
    text-align: center;
    color: #333;
    .close-toast {
      position: absolute;
      left: 40px;
      top: 50px;
      width: 28px;
      height: 28px;
    }
  }
  .welfare-content {
    padding: 0 40px;
    .welfare-box-img {
      background: #e9faef;
      border-radius: 10px;
      padding: 15px 45px;
      margin-bottom: 55px;
      image {
        width: 160px;
        height: 78px;
      }
      view {
        font-size: 26px;
        color: #333;
        margin-left: 17px;
        line-height: 40px;
      }
    }
    .welfare-box-field {
      display: flex;
      align-items: flex-start;
      margin-bottom: 40px;
      image {
        width: 56px;
        height: 56px;
        margin-right: 20px;
      }
      &_subtext {
        font-size: 28px;
        color: #666666;
        margin-top: 12px;
      }
      &_text {
        font-size: 32px;
        color: #333;
        line-height: 56px;
      }
    }
  }
}

.button-wrap {
  background: #fff;
  text-align: center;
  padding-bottom: 30px;
  height: 190px;

  .apply-btn {
    width: 640px;
    height: 90px;
    display: block;
    margin: 0 auto;
    background: linear-gradient(
      180deg,
      rgba(13, 226, 164, 1) 0%,
      rgba(21, 195, 195, 1) 100%
    );
    box-shadow: 0px 6px 12px 0px rgba(12, 161, 147, 0.35);
    border-radius: 75px;
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 30px;
  }
  .custom-link {
    color: #0094ee;
    font-size: 28px;
    display: inline-block;
    padding: 0 40px;
  }

  .button-fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    width: 100%;
    z-index: 10;
    padding: 40px 0;
    border-top: 1px solid #dddddd;
  }
}
</style>
